<template>
  <generic-historical 
    :get-detalle="getDetalleAux"
    :get-pag="getPagAux"
    :get-excel="getExcelAux"
    :get-params="getParamsAux"
    :get-params-detalle="getParamsDetalleAux"
    :excel-name="ExcelName"
    :id-vista="idVista"
    :header-url="headerUrl"
    :breadcrumbs="breadcrumbs"
    :vuexnamespace="vuexnamespace" />
</template>

<script>
import _ from 'lodash'
import { i18n } from '@/i18n'
import GenericHistorical from '@/views/historical/GenericHistorical.vue'
import { getGroup } from '@/services/configurations/groups/getGroup'
import { getHistoricalByGroup } from '@/services/historical/getHistoricalByGroup'
import { getHistoricalByGroupExcel } from '@/services/historical/getHistoricalByGroupExcel'

export default {
  name: 'list-group-historical',
  components: {
    GenericHistorical
  },
  data: function () {
    return {
      idVista: 49,
      vuexnamespace: 'historicalGroup',
      headerUrl: 'configurations/groups/details',
      breadcrumbs: [
        { 
          url: this.role === 3 ? 'configurationssa' : 'configurations', 
          name: i18n.t('configurations.header') 
        },
        { url: 'configurations/groups', name: i18n.t('groups.header') },
        { paths: ['Nombre'] },
      ],
      ExcelName: `${_.kebabCase(i18n.t('groups.entity_name') + i18n.t('historical.entity_name'))}.xlsx`,
    }
  },
  methods: {
    getParamsAux: function (data) {
      return { idGrupo: this.$route.params.id }
    },
    getParamsDetalleAux: function (data) {
      return this.getParamsAux(data)
    },
    getDetalleAux: async function (params) {
      return await getGroup(params)
    },
    getExcelAux: async function (payload, params) {
      return await getHistoricalByGroupExcel(payload, params)
    },
    getPagAux: async function (payload, params) {
      return await getHistoricalByGroup(payload, params)
    },
  }
}
</script>

<style lang="scss" scoped></style>
